// Helpers de fecha/hora para el hincha. Muestran en la zona horaria del dispositivo.

const DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

// "2026-06-11T19:00:00+00:00" -> "jue 11 jun · 16:00" (hora local del usuario).
export function formatKickoff(iso: string | null): string {
  if (!iso) return 'A definir';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'A definir';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} · ${hh}:${mm}`;
}

// Solo la hora local: "16:00".
export function formatTime(iso: string | null): string {
  if (!iso) return '--:--';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '--:--';
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

// Fecha larga en español: "jueves 11 de junio". Para encabezados de calendario.
export function formatDateLong(iso: string | null): string {
  if (!iso) return 'Fecha a definir';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'Fecha a definir';
  const s = d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// Clave de día local (YYYY-MM-DD) para agrupar por fecha de calendario.
export function dayKey(iso: string | null): string {
  if (!iso) return 'tbd';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'tbd';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Piezas para la estética calendario.
export function weekdayShort(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : DAYS[d.getDay()];
}
export function dayNum(iso: string | null): string {
  if (!iso) return '–';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '–' : String(d.getDate());
}
export function monthShort(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : MONTHS[d.getMonth()];
}

// Cuenta regresiva detallada hasta el inicio (para timer en vivo): "2d 05h 12m 30s".
export function countdownLong(iso: string | null): string {
  if (!iso) return '';
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return '¡Comienza!';
  const s = Math.floor(diff / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const p = (n: number) => String(n).padStart(2, '0');
  if (d > 0) return `${d}d ${p(h)}h ${p(m)}m`;
  if (h > 0) return `${p(h)}h ${p(m)}m ${p(sec)}s`;
  return `${p(m)}m ${p(sec)}s`;
}

// Cuenta regresiva corta hasta el inicio: "en 2 d", "en 3 h", "en 12 min", "¡ya!".
export function countdown(iso: string | null): string {
  if (!iso) return '';
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return '¡ya!';
  const min = Math.round(diff / 60000);
  if (min < 60) return `en ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `en ${h} h`;
  return `en ${Math.round(h / 24)} d`;
}
